import React, { useEffect } from 'react'
import { OidcSecure } from '@axa-fr/react-oidc'
import ReactGA from 'react-ga'
import dynamic from 'next/dynamic'

const WithLayout = dynamic(async () => (await import('../src/Component/Layout/LayoutView')).WithLayout, {
  ssr: false,
})

const AppContainer = dynamic(async () => (await import('../src/components/AppContainer')).AppContainer, {
  ssr: false,
})

export default function Home() {
  useEffect(() => {
    if (window) {
      const TRACKING_ID = process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_ID
      if (typeof TRACKING_ID === 'string') {
        ReactGA.initialize(TRACKING_ID)
      }
      ReactGA.pageview(window.location.pathname + window.location.search)
    }
  }, [])

  return (
    <div>
      <OidcSecure>
        <WithLayout>
          <AppContainer />
        </WithLayout>
      </OidcSecure>
    </div>
  )
}
